<template>
  <v-card :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" :class="$vuetify.breakpoint.xsOnly ? 'mb-2 mx-4' : 'mb-4'">
    <v-card-text>
      <v-text-field
        v-model="quotation.name"
        :label="$t('quotations.name')"
        :hint="quotation.siblings.length > 0 ? $t('quotations.project.name_shared') : ''"
        :persistent-hint="quotation.siblings.length > 0"
        :disabled="saving"
        :rules="[$rules.required]"
        outlined
        dense
        hide-details="auto"
      >
        <template v-slot:prepend><v-icon>mdi-folder-outline</v-icon></template>
      </v-text-field>
      <div v-if="quotation.siblings.length > 0" class="mt-3">
        <div class="caption grey--text text-uppercase mb-1">{{ $t('quotations.project.other_offers') }}</div>
        <div v-for="s in quotation.siblings" :key="s.id" class="d-flex align-center flex-wrap body-2 py-1">
          <router-link :to="{ name: 'tenant_quotation_edit', params: { id: s.id } }" class="font-weight-medium mr-2">{{ s.code || '–' }}</router-link>
          <span class="mr-2">{{ s.partyName || '–' }}</span>
          <quotation-status-chip :status="s.status" x-small />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import QuotationStatusChip from './QuotationStatusChip';

// Tarjottavan projektin nimi (yhteinen projektin kaikille tarjouksille) ja saman projektin muut tarjoukset
export default {
  name: 'QuotationProjectHeader',
  components: { QuotationStatusChip },
  props: {
    quotation: { type: Object, required: true },
    saving: { type: Boolean, default: false },
  },
};
</script>
